import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const scalingPlugin = createPlugin({
  id: 'scaling',
  routes: {
    root: rootRouteRef,
  },
});

export const ScalingWorkflowPage = scalingPlugin.provide(
  createRoutableExtension({
    name: 'ScalingWorkflowPage',
    component: () =>
      import('./components/WorkflowCard').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const PickReplicaPage = scalingPlugin.provide(
  createRoutableExtension({
    name: 'PickReplicaPage',
    component: () =>
      import('./components/pick-replica').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const PreviewReplicaPage = scalingPlugin.provide(
  createRoutableExtension({
    name: 'PreviewReplicaPage',
    component: () =>
      import('./components/PreviewReplicaPage').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const ServiceReplicaPage = scalingPlugin.provide(
  createRoutableExtension({
    name: 'ServiceReplicaPage',
    component: () =>
      import('./components/ServiceReplicaPage').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const UpdateServiceReplicaPage = scalingPlugin.provide(
  createRoutableExtension({
    name: 'UpdateServiceReplicaPage',
    component: () =>
      import('./components/update-service').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);
